import { Avatar, SxProps, Theme } from '@mui/material';

export type SidenavUserAvatarProps = {
  size: number;
  src?: string | null;
  initials: string;
  /** Extra styles for the initials fallback (typography differs rail vs popover). */
  initialsSx?: SxProps<Theme>;
};

/**
 * Circular user avatar: image when available, otherwise initials on the brand fallback color.
 */
export function SidenavUserAvatar({ size, src, initials, initialsSx }: SidenavUserAvatarProps) {
  return (
    <Avatar
      src={src || undefined}
      alt=""
      sx={
        [
          {
            width: size,
            height: size,
            bgcolor: 'sidenav.avatarFallback',
            flexShrink: 0,
            fontWeight: 600,
            letterSpacing: '0.05rem',
          },
          initialsSx,
        ] as SxProps<Theme>
      }
    >
      {initials}
    </Avatar>
  );
}
